var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfmFindSupplier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83013 12.0938C5.51713 12.0938 1.83313 14.7738 1.83313 17.4938C1.83313 20.2148 5.49413 20.9187 9.83013 20.9187C11.2192 20.9187 12.5431 20.8483 13.6996 20.6619C12.8333 19.918 11.3333 17.918 11.3333 16.918C11.3333 15.918 11.3333 13.918 12.5334 12.4499C11.6848 12.2217 10.7735 12.0938 9.83013 12.0938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83015 11.502C12.7681 11.502 15.1221 9.14697 15.1221 6.20997C15.1221 3.27297 12.7681 0.917969 9.83015 0.917969C6.89315 0.917969 4.53815 3.27297 4.53815 6.20997C4.53815 9.14697 6.89315 11.502 9.83015 11.502Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7167,
    cy: 15.799,
    r: 4.49428,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8425 19.1602L22.6045 20.9176",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfmFindSupplier);
export default __webpack_public_path__ + "static/media/rfm-find-supplier.176e49bdeb1689b3b59b641936550c3c.svg";
export { ForwardRef as ReactComponent };